export var StatusTests;
(function (StatusTests) {
    StatusTests["NO_TESTS_FOUND"] = "no_runned_tests";
    StatusTests["ALL_TESTS_PASSED"] = "all_tests_passed";
    StatusTests["FAILED_TESTS"] = "failed_tests";
})(StatusTests || (StatusTests = {}));
